import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=2e39a244&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"
import style0 from "./Account.vue?vue&type=style&index=0&id=2e39a244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e39a244",
  null
  
)

export default component.exports